import { useApp } from '@context/AppContext';

/**
 * 3-second transition overlay between relay turns.
 * Canvas darkens, next drawer announced.
 */
export default function RelayTransition() {
  const { state } = useApp();
  const { game, room, user } = state;

  const nextDrawerName = room.members?.[game.currentDrawerId]?.nickname || 'Unknown';
  const isYou = game.currentDrawerId === user.id;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm">
      <div className="text-center animate-[fadeIn_0.3s_ease-out]">
        <p className="text-lg text-white/60 font-display mb-2">Next up</p>
        <p className="text-4xl font-bold text-white font-display mb-2">
          {isYou ? "You're drawing!" : nextDrawerName}
        </p>
        {isYou && (
          <p className="text-lg text-amber font-display animate-pulse">Get ready...</p>
        )}
        {game.theme && (
          <p className="text-sm text-white/40 font-display mt-4">
            Theme: {game.theme}
          </p>
        )}
      </div>
    </div>
  );
}
